/*
 * View for modifying response properties, such as the associated content
 * and escalations
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicTasks/template/topicTasksTemplate.html",
], function (Marionette, Messenger, TopicTasksTemplate) {
  var TopicTasksView = {};

  TopicTasksView.topicTasksLayout = Marionette.Layout.extend({
    template: TopicTasksTemplate,
    regions: {
      list: "#taskList",
      area: "#taskArea",
      listToggle: "#taskListToggle",
    },
    //use events instead of triggers so that the click events will propagate and close the dropdown
    events: {
      "click #newTopicReview": function (e) {
        this.trigger("new:topic:review");
        e.preventDefault(); //don't let the link actually work
      },
      "click #newUpdateResponse": function (e) {
        this.trigger("new:update:response");
        e.preventDefault();
      },
      "click #newTranslateResponse": function (e) {
        this.trigger("new:translate:response");
        e.preventDefault();
      },
      "click #newAdvancedTask": function (e) {
        e.preventDefault();
        this.trigger("new:advanced:task");
      },
    },
    resetTaskArea: function () {
      this.area.reset();
    },
  });

  return TopicTasksView;
});
